module.exports = __webpack_public_path__ + "img/remote-access.2034bbb3.svg";